import { ReactElement, useMemo } from 'react';
import { formatISO, startOfYear, endOfYear } from 'date-fns';
import { DateRangePeriodPicker, Visibility, VisibilityProps } from '../common';
import { columns } from './columns';
import { Row } from './types';
import { TextField } from '@ff-it/form';
import { CompanyField } from 'modules/core/company/components';
import { BrandField } from 'modules/client/brand/components';
import { TableColumns } from '@ff-it/ui';
import { ReportTable } from 'components/ReportTable';
import { StateFilterField, TypeFilterField } from '../Filter';
import { EnterpriseField } from 'components';

const resolveColumns = (visibility: Visibility): TableColumns<Row> => {
  switch (visibility) {
    case 'GLOBAL':
      return columns;
    case 'LOCAL':
      // no agency
      return columns.slice(1);
    case 'LOCAL_MANAGED':
    case 'LOCAL_TYPE':
      // no agency, no bonuses
      return columns.slice(1, 10);
  }
};

export function Campaign({ visibility, ...props }: VisibilityProps): ReactElement {
  const initialFilter = {
    date_from: formatISO(startOfYear(new Date()), { representation: 'date' }),
    date_to: formatISO(endOfYear(new Date()), { representation: 'date' }),
  };

  const url = `reporting/campaign/${visibility.toLowerCase()}${'type' in props ? `/${props.type}/` : '/'}`;

  const columns = useMemo(() => {
    return resolveColumns(visibility);
  }, [visibility]);

  return (
    <ReportTable
      url={url}
      defaultFilter={initialFilter}
      columns={columns}
      filterFields={
        <div className="flex-column">
          <div className="d-flex flex-row">
            <DateRangePeriodPicker />
            <CompanyField name="clients" isMulti placeholder="Client" className="ml-2" simple includeBranches={true} />
            <CompanyField name="payers" isMulti placeholder="Payer" className="ml-2" simple includeBranches={true} />
            <TextField name="search_campaign" placeholder="Campaign title or number" className="ml-2" />
            <BrandField name="brand" placeholder="Brand" className="ml-2" simple />
            <EnterpriseField name="agency" isMulti className="ml-1" defaultOptions placeholder="All agencies" simple />
          </div>
          <div className="d-flex flex-row">
            <StateFilterField />
            {visibility !== 'LOCAL_TYPE' && <TypeFilterField global={visibility === 'GLOBAL'} className="ml-1" />}
          </div>
        </div>
      }
    />
  );
}
